import { HeartStraightIcon, PlusIcon } from '@phosphor-icons/react';
import React from 'react';

import Button from '../../UI/Button';
import './AddFirstPet.scss';
import { AddFirstPetProps } from './types';

const AddFirstPet: React.FC<AddFirstPetProps> = ({ onClick }) => {
  return (
    <div className="add-first-pet">
      <div className="add-first-pet__icon-wrapper">
        <div className="add-first-pet__icon-circle">
          <HeartStraightIcon className="add-first-pet__heart-icon" weight="fill" />
          <div className="add-first-pet__plus-badge">
            <PlusIcon weight="bold" />
          </div>
        </div>
      </div>

      <div className="add-first-pet__content">
        <h2 className="add-first-pet__title">¡Aún no tienes mascotas!</h2>
        <p className="add-first-pet__description">
          Es hora de añadir a tu primer amigo peludo para empezar a gestionar su salud.
        </p>
      </div>

      <Button onClick={onClick}>Añadir nueva mascota</Button>
    </div>
  );
};

export default React.memo(AddFirstPet);
